class ProductMedia extends HTMLElement {
  constructor() {
    super();
    this.gallerySliderSlides = this.querySelectorAll('.product-media__gallery .product-media__slide');
    this.stickyHeader = document.querySelector('.sticky-header');
    this.announcementBarCloseBtn = document.querySelector('.announcement-bar__close');

    if (this.gallerySliderSlides.length > 1) {
      this.createSlider();
      window.addEventListener('resize', this.updateArrowState.bind(this));
      document.addEventListener('DOMContentLoaded', this.updateArrowState.bind(this));
    }

    window.addEventListener('scroll', this.stickyMedia.bind(this));
    window.addEventListener('resize', this.stickyMedia.bind(this));
    document.addEventListener('DOMContentLoaded', this.stickyMedia.bind(this));
    if (this.announcementBarCloseBtn) {
      this.announcementBarCloseBtn.addEventListener('click', this.stickyMedia.bind(this));
    }

    document.addEventListener('DOMContentLoaded', this.galleryZoom.bind(this));
  }

  createSlider() {
    const gallerySlider = this.querySelector('.product-media__gallery');
    const thumbnailsSlider = this.querySelector('.product-media__thumbnails');
    const thumbnailsSliderSlides = thumbnailsSlider?.querySelectorAll('.product-media__slide');

    thumbnailsSliderSlides.forEach((slide, index) => {
      slide.addEventListener('click', () => {
        // 1. Scroll to related slide
        gallerySlider.scrollTo({
          left:gallerySlider.clientWidth * index,
          behavior: "smooth",
        })

        // 2. active class
        thumbnailsSliderSlides.forEach(el => el.classList.remove('active'));
        slide.classList.add('active');
      })
    })

    // Thumbnails
    this.thumbnailsArrows();
    thumbnailsSlider.addEventListener('scroll', this.updateArrowState.bind(this));
  }

  thumbnailsArrows() {
    const thumbnailsSlider = this.querySelector('.product-media__thumbnails');
    const thumbnailsSliderSlides = thumbnailsSlider?.querySelectorAll('.product-media__slide');
    const leftArrow = this.querySelector('.arrow--left');
    const rightArrow = this.querySelector('.arrow--right');

    leftArrow.addEventListener("click", (e) => {
      if (e.target.closest('.arrow').classList.contains('arrow--disabled')) return;
      const thumbnailWidth = parseFloat(window.getComputedStyle(thumbnailsSliderSlides[0]).width);
      thumbnailsSlider.scrollBy({
        left: -thumbnailWidth,
        behavior: 'smooth'
      });

      setTimeout(this.updateArrowState.bind(this), 300);
    });
    
    rightArrow.addEventListener('click', (e) => {
      if (e.target.closest('.arrow').classList.contains('arrow--disabled')) return;
      const thumbnailWidth = parseFloat(window.getComputedStyle(thumbnailsSliderSlides[0]).width);
      thumbnailsSlider.scrollBy({
        left: thumbnailWidth,
        behavior: 'smooth'
      });

      setTimeout(this.updateArrowState.bind(this), 300);
    });
  }

  updateArrowState() {
    const thumbnailsSliderContainer = this.querySelector('.product-media__thumbnails-container');
    const thumbnailsSlider = this.querySelector('.product-media__thumbnails');
    const thumbnailsSliderSlides = thumbnailsSlider?.querySelectorAll('.product-media__slide');
    const leftArrow = this.querySelector('.arrow--left');
    const rightArrow = this.querySelector('.arrow--right');

    // 1. Show/hide arrows
    if (window.innerWidth >= 450) {
      if (thumbnailsSliderSlides.length > 4) thumbnailsSliderContainer.classList.add('show-arrows');
      else thumbnailsSliderContainer.classList.remove('show-arrows');
    } else {
      if (thumbnailsSliderSlides.length > 3) thumbnailsSliderContainer.classList.add('show-arrows');
      else thumbnailsSliderContainer.classList.remove('show-arrows');
    }

    // 2. arrow--disabled class
    const scrollLeft = thumbnailsSlider.scrollLeft;
    const scrollWidth = thumbnailsSlider.scrollWidth;
    const clientWidth = thumbnailsSlider.clientWidth;

    // Check left end
    if (scrollLeft <= 0) {
      leftArrow.classList.add('arrow--disabled');
    } else {
      leftArrow.classList.remove('arrow--disabled');
    }

    // Check right end
    if (scrollLeft + clientWidth >= scrollWidth - 1) { // Allow 1px buffer
      rightArrow.classList.add('arrow--disabled');
    } else {
      rightArrow.classList.remove('arrow--disabled');
    }
  }

  galleryZoom() {
    // A) Non touch screens - Drift
    // 1. Settings
    const driftImgs = [...document.querySelectorAll('.drift-img')];
    driftImgs.map(img => {
      const pane = img.closest('.product-media__slide');
      new Drift(img, {
        paneContainer: pane,
        zoomFactor: 1.5,
        inlinePane: 100,
        touchDelay: 500
      });
    });

    // 2. Add 'zoom-active' class on click
    const galleryImages = document.querySelectorAll('.product-media__gallery .media-container.type-image');
    galleryImages.forEach(img => {
      img.addEventListener('click', function() {
        const touch = matchMedia('(hover: none)').matches;
        if(!touch) img.classList.toggle('zoom-active');
      })
    })

    // B) Touch screens - Pinch
    const pinchZoomWrappers = document.querySelectorAll('.pinch-zoom');
    pinchZoomWrappers.forEach(el => {
      let pz = new PinchZoom(el, {
        minZoom: 0.9,
        draggableUnzoomed: false
      });
    })
  }

  stickyMedia() {
    if (window.innerWidth >= 990) {
      // Adjust top position
      this.querySelector('.product-media-inner').style.top = getComputedStyle(this.stickyHeader).height;
      for (let i = 1; i <= 300; i++) {
        setTimeout(() => {
          this.querySelector('.product-media-inner').style.top = getComputedStyle(this.stickyHeader).height;
        }, i);
      }
    }
  }
}

customElements.define('product-media', ProductMedia);

class ProductRating extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.onRatingClick);
  }

  onRatingClick() {
    const headerHeigt = parseInt(getComputedStyle(document.querySelector('.sticky-header')).height);
    const reviewsSection = document.getElementById('product-reviews');

    document.body.scrollTop = reviewsSection.offsetTop - headerHeigt;
    document.documentElement.scrollTop = reviewsSection.offsetTop - headerHeigt;
  }
}

customElements.define('product-rating', ProductRating);

class ProductDescription extends HTMLElement {
  constructor() {
    super();
    this.toggle = this.querySelector('.product-description__toggle');
    this.content = this.querySelectorAll('.product-description__content');
    this.btns = this.querySelectorAll('.product-description__btn');

    this.toggle.addEventListener('click', this.onToggleClick.bind(this));
    document.addEventListener('DOMContentLoaded', this.removeEmptyContent.bind(this));
    document.addEventListener('DOMContentLoaded', this.iframeAspectRatio.bind(this));
  }

  onToggleClick() {
    this.content.forEach(el => el.classList.toggle('hidden'));
    this.btns.forEach(el => el.classList.toggle('hidden'));
  }

  removeEmptyContent() {
    const longEl = this.querySelector('.product-description__long');
    const newLongHTML = longEl.innerHTML.replaceAll('<p>&nbsp;</p>', '');
    
    longEl.innerHTML = newLongHTML;
  }

  iframeAspectRatio() {
    const iframes = this.querySelectorAll('iframe');
    if (!iframes) return;

    iframes.forEach(iframe => {
      const iframeContainer =  document.createElement('div');
      iframeContainer.classList.add('iframe-container');
      iframe.insertAdjacentElement('beforebegin', iframeContainer);
      iframeContainer.insertAdjacentElement('afterbegin', iframe);
    })
  }
}

customElements.define('product-description', ProductDescription);

class ColorLinkify extends HTMLElement {
  constructor() {
    super();
    window.addEventListener('load', this.colorLinkifyOnLoad.bind(this));
    this.colors = this.dataset.colors;
  }

  colorLinkifyOnLoad() {
    // On load
    this.updateContent();

    // Check again in case the content is not yet available
    for (let i = 1; i <= 10; i++) {
      const ms = i * 500;
      setTimeout(() => {
        this.updateContent();
      }, ms);
    }
  }

  updateContent() {
    const label = this.querySelector('.webyzeProductColorsLabel');
    const swatchesBackground = this.querySelectorAll('.swatchProductColor > div');
    let labelEl = `<span class="color-linkify__label">Modelo:</span>`;
    let colorsEl;

    if (!label) return;
    if (this.classList.contains('content-updated')) return;
    
    // 1. Update label content
    if (this.colors) colorsEl = `<span class="color-linkify__colors">${this.colors}</span>`;
    label.innerHTML = `${labelEl} ${colorsEl ? colorsEl : ''}`;

    // 2. Update image size
    swatchesBackground.forEach(el => {
      const currentStyle = el.getAttribute('style');
      const newStyle = currentStyle.replace('_small', '_large')

      el.setAttribute('style', newStyle);
    })

    // 3. Show content
    this.classList.remove('hidden');
    this.classList.add('content-updated');
  }
}

customElements.define('color-linkify', ColorLinkify);

class MoreInfo extends HTMLElement {
  constructor() {
    super();
    this.links = this.querySelectorAll('.more-info__link');
    this.links.forEach(link => {
      link.addEventListener('click', this.openRelatedModal.bind(this));
    })
  }

  openRelatedModal(e) {
    e.preventDefault();
    const relatedModal = document.querySelector(e.target.closest('.more-info__content').dataset.modal);
    if (!relatedModal) return;
    relatedModal.classList.add('open');
  }
}
customElements.define('more-info', MoreInfo);

class ProductModal extends HTMLElement {
  constructor() {
    super();
    window.addEventListener('load', this.addTransition.bind(this));
    this.addEventListener('click', this.closeModal.bind(this));
  }

  closeModal(e) {
    if (e.target === this || e.target.closest('.icon-close')) this.classList.remove('open')
  }

  addTransition() {
    this.classList.add('transition');
  }
}

customElements.define('product-modal', ProductModal);

class VariantRadios extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.form = this.closest('.product-form');
  }

  onVariantChange(e) {
    this.getSelectedOptions();
    this.getSelectedVariant();
    if(this.currentVariant) {
      this.updateURL();
      this.updateFormID();
      this.updateProductInfo(e);
    }
  }

  getSelectedOptions() {
    const productOptionContainers = Array.from(this.querySelectorAll('.js-product-form-option'));
    this.options = productOptionContainers.map(el => {
      return Array.from(el.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }

  getVariantJSON() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  getSelectedVariant() {
    this.currentVariant = this.getVariantJSON().find(variant => {
      const findings = !variant.options.map((option, index) => {
        return option === this.options[index];
      }).includes(false);

      if(findings) return variant;
    });
  }

  updateURL() {
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateFormID() {
    const formInput = this.form.querySelector('input[name="id"]');
    formInput.value = this.currentVariant.id;
  }

  updateProductInfo(e) {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
    .then(response => response.text())
    .then(responseText => {
      const idPrice = `price-${this.dataset.section}`;
      const idMedia = `media-${this.dataset.section}`;
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const oldPrice = document.getElementById(idPrice);
      const newPrice = html.getElementById(idPrice);
      const oldProductMedia = document.getElementById(idMedia);
      const newProductMedia = html.getElementById(idMedia);
      const oldCTA = this.form.querySelector('.product-form__cta');
      const newCTA = html.querySelector('.product-form__cta');
      const oldStockAlert = document.querySelector('.product-low-stock-alert');
      const newStockAlert = html.querySelector('.product-low-stock-alert');
      
      // Price
      if (!this.pack) if (oldPrice && newPrice) oldPrice.innerHTML = newPrice.innerHTML;

      // Media
      if (oldProductMedia && newProductMedia) {
        oldProductMedia.innerHTML = newProductMedia.innerHTML;
        
        const that = document.getElementById(idMedia);

        if (that.gallerySliderSlides.length > 1) {
          that.createSlider();
          that.updateArrowState();
        }

        that.stickyMedia();
        that.galleryZoom();
      }
      
      // CTA buttons
      if (oldCTA && newCTA) oldCTA.innerHTML = newCTA.innerHTML;
      this.form.addToCartFunction();

      // Stock alert
      if (oldStockAlert && newStockAlert) oldStockAlert.innerHTML = newStockAlert.innerHTML;
    })
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductTabs extends HTMLElement {
  constructor() {
    super();
    this.allTabs = this.querySelectorAll('.product-tab');
    this.allTabsHeaders = this.querySelectorAll('.product-tab__header');

    this.allTabsHeaders.forEach(heading => {
      heading.addEventListener('click', this.onHeadingClick.bind(this));
    })
  }

  onHeadingClick(e) {
    const thisTab = e.target.closest('.product-tab');
    const productTabContainer = thisTab.querySelector('.product-tab__content-container');
    const productTabHeight = getComputedStyle(productTabContainer.querySelector('.product-tab__content')).height;

    // 1. Active class
    if (thisTab.classList.contains('active')) {
      thisTab.classList.remove('active');
    } else {
      this.allTabs.forEach(el => el.classList.remove('active'));
      thisTab.classList.add('active');
    }

    // 2. Content Animation
    if (thisTab.classList.contains('active')) {
      // Close all Tabs
      this.allTabs.forEach(el => el.querySelector('.product-tab__content-container').style.maxHeight = 0);
      // Open this tab
      productTabContainer.style.maxHeight = productTabHeight;
    } else {
      // Close this tab
      productTabContainer.style.maxHeight = 0;
    }
  }
}

customElements.define('product-tabs', ProductTabs);

class ProductModel extends HTMLElement {
  constructor() {
    super();
    this.poster = this.querySelector('.product-model__poster');

    this.poster?.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
      this.appendChild(content.querySelector('model-viewer'));

      this.setAttribute('loaded', true);
    }

    Shopify.loadFeatures([
      {
        name: 'model-viewer-ui',
        version: '1.0',
        onLoad: this.setupModelViewerUI.bind(this),
      },
    ]);
  }

  setupModelViewerUI(errors) {
    if (errors) return;

    this.modelViewerUI = new Shopify.ModelViewerUI(this.querySelector('model-viewer'));
  }
}

customElements.define('product-model', ProductModel);